// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-div{
    width: 100%;
    min-height: 100vh;
}

.grid{
    box-shadow: none !important;
}

.dashboard-title{
    width: fit-content;
    font-family: 'Arial Nova', Arial, sans-serif; /* Add fallback fonts */
    font-size: 18px !important;
    letter-spacing: 1px;
    font-weight: 500;
    color: black;
}



`, "",{"version":3,"sources":["webpack://./src/app/pages/home/Home.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,4CAA4C,EAAE,uBAAuB;IACrE,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB","sourcesContent":[".main-div{\n    width: 100%;\n    min-height: 100vh;\n}\n\n.grid{\n    box-shadow: none !important;\n}\n\n.dashboard-title{\n    width: fit-content;\n    font-family: 'Arial Nova', Arial, sans-serif; /* Add fallback fonts */\n    font-size: 18px !important;\n    letter-spacing: 1px;\n    font-weight: 500;\n    color: black;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
